import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {INSTRUCTIONS_SEARCH_QUERY_KEY, INSTRUCTIONS_TENANT_ID} from '../../consts'
import {mapInstructionDto} from '../../mappers'
import {
  InstructionsDto,
  DocumentSearchCriteria,
  Instruction,
  InstructionDto
} from '../../types/documents.types'

type Params = {
  plantId: string
  timezone: string
  settings: DocumentSearchCriteria
  options?: Omit<UseQueryOptions<InstructionDto[], AxiosError, Instruction[]>, 'queryKey'>
}

export const useFilteredInstructions = ({plantId, timezone, settings, options}: Params) => {
  return useQuery<InstructionDto[], AxiosError, Instruction[]>({
    queryKey: [INSTRUCTIONS_SEARCH_QUERY_KEY, settings, plantId, timezone],
    queryFn: async () => {
      const response = await ApiClient.axiosInstance.get<InstructionsDto>(
        `/instructions/${INSTRUCTIONS_TENANT_ID}/plants/${plantId}/filtered-instructions`,
        {
          params: settings
        }
      )
      return response.data
    },
    ...options,
    select: (data) => data.map((instruction) => mapInstructionDto(instruction, timezone))
  })
}
